"use client";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { clientEnv } from "#/lib/env/client";

let posthogInitialized = false;

if (typeof window !== "undefined" && !posthogInitialized) {
  posthog.init(clientEnv.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: clientEnv.VITE_PUBLIC_POSTHOG_HOST,
    ui_host: "https://app.posthog.com",
    capture_pageview: false,
  });
  posthogInitialized = true;
}

export default function Providers({
  children,
}: {
  children: React.ReactNode;
}) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
